(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["welvet-focus-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('welvet-focus-carousel')) {
  customElements.define('welvet-focus-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.track = this.querySelector('.wf-track');
      this.track.querySelectorAll('.wf-ghost').forEach(card => card.remove());
      this.cards = [...this.track.querySelectorAll('[data-carousel-card]')];
      if (!this.cards.length) return;
      this.index = 0;
      this.classList.add('is-ready');
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.disabled = this.cards.length < 2;
        button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options);
      });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.move(-this.index);
        else if (event.key === 'End') this.move(this.cards.length - 1 - this.index);
        else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.track.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !event.isPrimary) return;
        this.pointer = {x: event.clientX, y: event.clientY};
        this.suppressClick = false;
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.track.setPointerCapture(event.pointerId);
          this.suppressClick = true;
        }
      }, options);
      this.track.addEventListener('pointerup', event => {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.2) this.move(dx < 0 ? 1 : -1);
      }, options);
      this.track.addEventListener('pointercancel', () => { this.pointer = null; }, options);
      (this.closest('[data-set-feature]') || this).addEventListener('wheel', event => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 1 || event.ctrlKey) return;
        event.preventDefault();
        clearTimeout(this.wheelTimer);
        this.wheelTimer = setTimeout(() => {this.wheelTotal = 0;this.wheelSwitched = false;}, 180);
        if (this.wheelSwitched) return;
        this.wheelTotal = (this.wheelTotal || 0) + event.deltaX;
        if (Math.abs(this.wheelTotal) > 40) {this.move(this.wheelTotal > 0 ? 1 : -1);this.wheelSwitched = true;}
      }, {...options,passive:false});
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; }
      }, options);
      this.update(false);
    }
    disconnectedCallback() { this.abort?.abort();clearTimeout(this.wheelTimer); }
    move(direction) {
      if (this.cards.length < 2) return;
      const focusedCard = this.track.contains(document.activeElement) && document.activeElement !== this.track;
      this.index = (this.index + direction + this.cards.length) % this.cards.length;
      this.style.setProperty('--wf-arrive', direction > 0 ? '16px' : '-16px');
      this.update(true);
      if (focusedCard) this.cards[this.index].focus({preventScroll:true});
    }
    update(announce) {
      this.track.querySelectorAll('.wf-ghost').forEach(card => card.remove());
      this.cards.forEach((card, index) => {
        card.hidden = index !== this.index;
        card.classList.toggle('is-current', index === this.index);
      });
      if (this.cards.length > 1 && !this.hasAttribute('data-side-controls')) {
        [-1, 1].forEach(direction => {
          const card = this.cards[(this.index + direction + this.cards.length) % this.cards.length].cloneNode(true);
          card.hidden = false;
          card.removeAttribute('id');
          card.removeAttribute('data-carousel-card');
          card.classList.remove('is-current');
          card.classList.add('wf-ghost', direction < 0 ? 'wf-ghost--previous' : 'wf-ghost--next');
          card.setAttribute('aria-hidden', 'true');
          card.setAttribute('tabindex', '-1');
          this.track.append(card);
        });
      }
      this.querySelector('.wf-count').textContent = `${this.index + 1} / ${this.cards.length}`;
      const active = this.cards[this.index];
      if (announce) this.querySelector('[data-carousel-status]').textContent = active.dataset.title;
      const section = this.closest('[data-set-feature]');
      if (section) section.querySelectorAll('[data-set-model]').forEach(model => {
        const selected = model.dataset.setModel === active.dataset.model;
        model.hidden = !selected;
        if (selected) model.querySelector('img')?.setAttribute('loading', 'eager');
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["welvet-product-view-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('welvet-product-views')) {
  customElements.define('welvet-product-views', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.link = this.querySelector('.wv-link');
      this.view = 0;
      this.classList.add('is-ready');
      this.querySelectorAll('[data-photo-select]').forEach(button => button.addEventListener('click', () => {
        this.view = Number(button.dataset.photoSelect);
        this.show(this.view);
      }, options));
      this.link.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(min-width:901px) and (hover:hover) and (pointer:fine)').matches) this.show(1);
      }, options);
      this.link.addEventListener('pointerleave', () => this.show(this.view), options);
      this.link.addEventListener('dragstart', event => event.preventDefault(), options);
      this.show(0);
    }
    disconnectedCallback() {this.abort?.abort();}
    show(index) {
      this.dataset.view = String(index);
      this.querySelectorAll('[data-photo]').forEach(photo => photo.setAttribute('aria-hidden', String(Number(photo.dataset.photo) !== index)));
      this.querySelectorAll('[data-photo-select]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.photoSelect) === index)));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
